<template lang="html">
    <ul class="main-menu__submenu">
        <li class="main-menu__item">
            <router-link v-bind:to="{ name: 'Customers'}" v-bind:class="activeMenu">
                <md-icon>person</md-icon>
                <span>Контрагенты</span>
            </router-link>
        </li>
    </ul>
</template>
<script>
    export default {
        name: 'customers-main-menu',
        sort: 4,
        module: 'customers',
        data() {
            return {
                module: 'customers'
            }
        },
        computed: {
            activeMenu() {
                let routes = ['Customers', 'Customer', 'CustomerCreate', 'CustomerEdit', 'CustomerGroups', 'CustomerGroup'];
                return (routes.indexOf(this.$route.name)+1) ? this.$router.options.settingsLinkActiveClass : '';
            }
        },
    }
</script>



// WEBPACK FOOTER //
// MainMenu.vue?242aa7ec